import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataInput} from '../../dtos/data-input';
import {TEMOST_CONST} from '../../EnumsConstants/global-enum';
import {DataStorageService} from '../../services/data-storage.service';
import {DownloadService} from '../../services/download.service';
import {ExportDataService} from '../../services/export-data.service';
import {AnalyticsInjectorService} from '../../services/analytics/analytics.injector.service';

@Component({
  selector: 'app-info-box-export-datalist',
  templateUrl: './info-box-export-datalist.component.html',
  styleUrl: './info-box-export-datalist.component.scss',
  standalone: false
})
export class InfoBoxExportDatalistComponent {
  @Input() content: string;
  @Input() inputData: DataInput;

  constructor(
    private readonly exportDataService: ExportDataService,
    private readonly storage: DataStorageService,
    private readonly download: DownloadService,
    private readonly translate: TranslateService,
    private readonly analyticsInjector: AnalyticsInjectorService
  ) {}

  async exportDataSheet() {
    const isModule2 = await this.storage.getIsForModule2();
    const title = `Logib Export Datasheet ${isModule2 ? 'M2' : 'M1'}`;
    this.analyticsInjector.init(title);

    const sender = isModule2
      ? TEMOST_CONST.Sender.Module2
      : TEMOST_CONST.Sender.Module1;
    const module = isModule2 ? 'M2' : 'M1';

    this.exportDataService.getData(this.inputData).then(data => {
      this.download.exportExcelAnalyseData(
        data,
        this.translate.currentLang,
        sender,
        module
      );
    });
  }
}
